export const socketUrl = process.env.REACT_APP_URL_WEB_SOCKET;
